import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraICTThirdPartyProvider } from '../../models/doraICTThirdPartyProvider.ts';

interface DoraICTThirdPartyProviderState {
  doraICTThirdPartyProviders: DoraICTThirdPartyProvider[];
  selectedDoraICTThirdPartyProvider: DoraICTThirdPartyProvider | null;
}

const initialState: DoraICTThirdPartyProviderState = {
  doraICTThirdPartyProviders: [],
  selectedDoraICTThirdPartyProvider: null,
};

const doraICTThirdPartyProviderSlice = createSlice({
  name: 'doraICTThirdPartyProvider',
  initialState,
  reducers: {
    setDoraICTThirdPartyProviders(state, action: PayloadAction<DoraICTThirdPartyProvider[]>) {
      state.doraICTThirdPartyProviders = action.payload;
    },
    addDoraICTThirdPartyProvider(state, action: PayloadAction<DoraICTThirdPartyProvider>) {
      state.doraICTThirdPartyProviders.push(action.payload);
    },
    updateDoraICTThirdPartyProvider(state, action: PayloadAction<DoraICTThirdPartyProvider>) {
      const index = state.doraICTThirdPartyProviders.findIndex(provider => provider.id === action.payload.id);
      if (index !== -1) state.doraICTThirdPartyProviders[index] = action.payload;
    },
    removeDoraICTThirdPartyProvider(state, action: PayloadAction<number>) {
      state.doraICTThirdPartyProviders = state.doraICTThirdPartyProviders.filter(provider => provider.id !== action.payload);
    },
    setSelectedDoraICTThirdPartyProvider(state, action: PayloadAction<DoraICTThirdPartyProvider | null>) {
      state.selectedDoraICTThirdPartyProvider = action.payload;
    },
  },
});

export const {
  setDoraICTThirdPartyProviders,
  addDoraICTThirdPartyProvider,
  updateDoraICTThirdPartyProvider,
  removeDoraICTThirdPartyProvider,
  setSelectedDoraICTThirdPartyProvider,
} = doraICTThirdPartyProviderSlice.actions;

export const selectDoraICTThirdPartyProviders = (state: RootState) => state.doraICTThirdPartyProvider.doraICTThirdPartyProviders;
export const selectSelectedDoraICTThirdPartyProvider = (state: RootState) => state.doraICTThirdPartyProvider.selectedDoraICTThirdPartyProvider;

export default doraICTThirdPartyProviderSlice.reducer;
